import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/about.css";
import AOS from "aos";
import "aos/dist/aos.css";

const NewSubmenu1 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
    AOS.refresh();
  }, []);

  return (
    <div>
      {/* HERO SECTION */}
      <section className="about-hero" data-aos="fade-up">
        {/* BLURRED IMAGE LAYER */}
        <div className="hero-bg"></div>

        {/* CONTENT (NOT BLURRED) */}
        <div className="hero-content text-center text-white">
          <div className="container">
            <h1 className="fw-bold text-white">NATURE OF WORK </h1>
            <p className="mt-3">
              Work comprises of professional work mainly relating to real
              estates and commercial laws as under: -
            </p>
          </div>
        </div>
      </section>
      <section
        className="about-content"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="container mt-4 mb-3">
          <p>
            <h4>Real Estate :</h4>
            (i) Legal Management in Redevelopment / Self Redevelopment Projects
            from inception till completion of the Project.
            <br />
            (ii) Drafting of documents relating to properties such as
            Development Agreements, Power of Attorney, PAAA, Agreements for
            Sale, Conveyances, Leases etc.
            <br />
            (iii) Drafting of Agreements for share purchases.
            <br />
            (iv) Security Documentation relating to project finance relating to
            real estate projects. Private Equity, Loans from banks and financial
            instructions for projects including housing finance;
            <br />
            (v) Joint Ventures & Technical Knowhow Agreements;
            <br />
            (vi) Technical Collaboration Agreements;
            <br />
            (vii) Take-over Agreements.
          </p>
          <h4>Litigation :</h4>
          <p>
            Handling Litigation before the Hon’ble Supreme Court of India and
            Hon’ble Bombay High Court, RERA, State Consumer Forum, NCLT,
            Arbitrations, Co-operative Sector etc.
          </p>
          <h4>Social :</h4>
          <p>
            Conducting Seminars, Conferences, lectures and TV & Radio Shows on
            Self Redevelopment, Cooperative Laws and Constitutional Laws.
            YouTube Channel – VIDELICET LAW
          </p>
        </div>
      </section>
    </div>
  );
};

export default NewSubmenu1;
